module.exports = __webpack_public_path__ + "img/logo-big.dba6b784.png";